import { render, staticRenderFns } from "./EditDiskForm.vue?vue&type=template&id=e6ec7ed2&"
import script from "./EditDiskForm.vue?vue&type=script&lang=ts&"
export * from "./EditDiskForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports